/* projects/shared/components/time-out-dialog/time-out-dialog.component.scss */
:host {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 496px;
  height: auto;
  border-radius: 12px;
  gap: var(--space-m);
  overflow: hidden;
}
@media screen and (max-width: 767px) {
  :host {
    width: auto;
    height: auto;
    gap: 0px;
    padding: 20px;
  }
}
:host .dialog-content {
  padding: 20px 20px 0px;
  overflow: hidden;
}
@media screen and (max-width: 767px) {
  :host .dialog-content {
    width: auto;
    padding: 0px;
  }
}
:host .warning-message {
  font-size: var(--font-s);
  color: black;
  line-height: 25px;
}
:host .dialog-actions {
  align-self: flex-end;
  text-align: right;
  grid-column-gap: var(--space-s);
  padding: 0px 15px 15px;
}
@media screen and (max-width: 767px) {
  :host .dialog-actions {
    width: auto;
    margin-bottom: unset;
    justify-content: right;
    padding: 0px;
  }
}
/*# sourceMappingURL=time-out-dialog.component-MPNPMK5Y.css.map */
